import { createApi, toJson } from 'unsplash-js';
import _ from 'lodash';

const APP_ACCESS_KEY = 'qHFwDG61nFNxg4G20VV8FRFNiOcf_RkZLzH1OGR7QR0';
const unsplash = createApi({ accessKey: APP_ACCESS_KEY });

export default {
  searchPhotos(search, page = 1, perPage = 10) {
    // Mode dev, pas besoin d'utiliser l'API
    if (process.env.NODE_ENV === 'development') {
      return Promise.resolve({ results: [] });
    }
    return unsplash.search
      .photos(search, page, perPage, { orientation: 'landscape' })
      .then(toJson);
  },
  getSmallImage(photo) {
    return _.get(photo, `urls.small`, null);
  },
  getUnsplashUrl(photo) {
    return _.get(photo, `links.html`, null);
  },
  getAuthor(photo) {
    return _.get(photo, `user.name`, null);
  },
};
